import { isDraftWaypointDenormalized, getWaypointStatusInfo } from '@caresend/utils';
import 'dayjs';
import '@caresend/types';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';

/**
 * If draftWaypoint is denormalized, return the statusInfo from the draftWaypoint.
 * Otherwise, build and return the statusInfo as built from the draftWaypoint status
 */
const getWaypointCardStatusInfo = (
/** Draft waypoint only passed in case of just-created order in pro. */
draftWaypoint, offlineScheduling) => {
    if (isDraftWaypointDenormalized(draftWaypoint)) {
        return draftWaypoint.statusInfo;
    }
    return getWaypointStatusInfo(draftWaypoint, 
    /** waypoint */
    undefined, 
    /** procedureStatuses */
    undefined, offlineScheduling);
};

export { getWaypointCardStatusInfo };
